import { CommonModule } from '@angular/common';
import { Component, inject, Injectable } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { TranslateModule } from '@ngx-translate/core';
import { BaseDialogService, NonNullableConfigData, TilbyDialogContentComponent, TilbyDialogToolbarComponent } from '@tilby/tilby-ui-lib/components/tilby-dialog';
import { lastValueFrom } from 'rxjs';

export interface DialogOption {
  name: string;
  value: any;
}

export interface DialogField {
  message?: string;
  placeholder: string;
  required?: boolean;
  default?: any;
  options: DialogOption[];
}

export interface OptionsDialogData {
  title: string;
  fields: DialogField[];
  hideCancel?: boolean;
}

@Component({
  selector: 'app-options-selector-dialog',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    MatSelectModule,
    TilbyDialogContentComponent,
    TilbyDialogToolbarComponent,
    TranslateModule,
    MatFormFieldModule,
    ReactiveFormsModule,
  ],
  templateUrl: './options-selector-dialog.component.html',
  styleUrl: './options-selector-dialog.component.scss'
})
export class OptionsSelectorDialogComponent {

  protected readonly data: OptionsDialogData = inject(MAT_DIALOG_DATA);
  private readonly matDialogRef = inject(MatDialogRef);
  private readonly fb = inject(FormBuilder);

  optionsForm!: FormGroup;

  ngOnInit() {
    console.log("DATA ", this.data);
    this.initForm();
  }

  private initForm() {
    this.optionsForm = this.fb.group({
      selections: this.fb.array([])
    });

    this.initFields();
  }

  
  get selections(): FormArray {
    return this.optionsForm.get('selections') as FormArray;
  }

  private initFields() {
    this.data.fields.forEach(field => {
      const control = this.fb.control(
          field.default ?? null, 
          field.required ? Validators.required : []
      );
      this.selections.push(control);
    });
  }

  confirm() {
    if (this.optionsForm.valid) {
      this.matDialogRef.close(this.selections.value);
    }
  }
}

@Injectable({
    providedIn: 'root',
})
export class OptionsSelectorDialogService extends BaseDialogService {
    private readonly dialog = inject(MatDialog);

    public openDialog(config?: NonNullableConfigData<OptionsDialogData>): Promise<any> {
        const data: OptionsDialogData = config?.data || { title: '', fields: []};
        
        const configEdited: NonNullableConfigData<OptionsDialogData> = {
          ...config,
          ...this.switchMobileDesktopDimensions({width: '600px'}),
          disableClose: true,
          data
        };

        return lastValueFrom(
          this.dialog.open(OptionsSelectorDialogComponent, configEdited).afterClosed()
        );
    }
}
